import { MyWorldIndexRouteBase } from 'mewe/routes/app/myworld.js';
import { objectToQueryString } from 'mewe/shared/utils';
import { next } from '@ember/runloop';

export default MyWorldIndexRouteBase.extend({

  activate(transition) {
    next(() => {
      let queryParams = transition.to.queryParams;

      // remove empty query parameters
      Object.keys(queryParams).forEach(key => {
        if (queryParams[key] === '' || queryParams[key] === null || queryParams[key] === undefined) {
          delete queryParams[key];
        }
      });
      // remove uri param that comes from BE redirection to /to-front
      delete queryParams.uri;

      // replace 'app.myworld.single-post' with 'public-post' in the url.
      // This way if user copies that link it should lead to public post route.
      // (hacky solution but useful for now, maybe routing should be improved for in app post links opening)
      window.history.pushState('', '', `/post/show/${transition.to.params.post_id}?${objectToQueryString(queryParams)}`);
    });
  },

  model: function (params, transition) {
    const onClose = () => {
      // replace post route with myworld route after closing SPV
      window.history.pushState('', '', '/myworld');
    };

    if (transition.to.queryParams.groupId) {
      const groupId = transition.to.queryParams.groupId;
      this.dispatch('feed', 'openSinglePost', {
        scope: 'group',
        groupId: groupId,
        postItemId: params.post_id,
        spvSource: 'link',
        onClose,
      });
    } else if (transition.to.queryParams.ppId) {
      const pagePublicLinkId = transition.to.queryParams.ppId;
      this.dispatch('feed', 'openSinglePost', {
        scope: 'page-link-id',
        pageId: pagePublicLinkId,
        postItemId: params.post_id,
        spvSource: 'link',
        onClose,
      });
    } else if (transition.to.queryParams.eventId) {
      const eventId = transition.to.queryParams.eventId;
      this.dispatch('feed', 'openSinglePost', {
        scope: 'event',
        eventId: eventId,
        postItemId: params.post_id,
        spvSource: 'link',
        onClose,
      });
    } else {
      this.dispatch('feed', 'openSinglePost', {
        scope: 'contacts',
        postItemId: params.post_id,
        spvSource: 'link',
        onClose,
      });
    }

    return this._super(...arguments);
  },
});
